"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arquivoModelos = void 0;
exports.arquivoModelos = [
    // {
    //   id: '1,
    //   nome: '',
    // },
    // {
    //   id: '2,
    //   nome: '',
    // },
    {
        id: '3',
        nome: 'Modelo 2000-PR',
    },
    {
        id: '4',
        nome: 'Modelo Col. São Domingos',
    },
    {
        id: '5',
        nome: 'Modelo MT Geral',
    },
    {
        id: '6',
        nome: 'Modelo MT 1ª a 4ª',
    },
    {
        id: '7',
        nome: 'Modelo N. S. Glória',
    },
    {
        id: '8',
        nome: 'Modelo Escola Descobrindo A Vida',
    },
    {
        id: '9',
        nome: 'Modelo 2000-PR - Pré-Impresso',
    },
    {
        id: '10',
        nome: 'Modelo Santo Inácio Texto',
    },
    {
        id: '11',
        nome: 'Modelo 1999-PR - Pré-Impresso',
    },
    {
        id: '12',
        nome: 'Modelo 1999-PR - A',
    },
    {
        id: '13',
        nome: 'Modelo 2000-PR - A - Único',
    },
    {
        id: '14',
        nome: 'Modelo 2000-PR - B - Com Carga Horária',
    },
    {
        id: '15',
        nome: 'Modelo Bahia',
    },
    {
        id: '16',
        nome: 'Modelo Anglo',
    },
    {
        id: '17',
        nome: 'Modelo Mãe de Deus Regular',
    },
    {
        id: '18',
        nome: 'Modelo Mãe de Deus Técnico',
    },
    {
        id: '19',
        nome: 'Modelo Sion Técnico',
    },
    {
        id: '20',
        nome: 'Modelo Anglo - Estado',
    },
    {
        id: '21',
        nome: 'Modelo Santa Maria - Pré-Impresso',
    },
    {
        id: '22',
        nome: 'Modelo Roland',
    },
    {
        id: '23',
        nome: 'Modelo São José - Apucarana',
    },
    {
        id: '24',
        nome: 'Modelo São José - Apucarana - 2 Anos',
    },
    {
        id: '25',
        nome: 'Modelo Paragominas',
    },
    {
        id: '26',
        nome: 'Modelo 2000-PR - B - Sem Carga Horária',
    },
    {
        id: '27',
        nome: 'Modelo Sion - Magistério',
    },
    {
        id: '28',
        nome: 'Modelo Educ. Nª Senhora Aparecida - SP',
    },
    {
        id: '29',
        nome: 'Modelo Supletivo',
    },
    {
        id: '30',
        nome: 'Modelo São Vicente de Paulo - Araucária',
    },
    {
        id: '31',
        nome: 'Modelo Supletivo Antigo',
    },
    {
        id: '32',
        nome: 'Modelo 2000-PR - A - Único Com RG',
    },
    {
        id: '33',
        nome: 'Modelo São Camilo',
    },
    {
        id: '34',
        nome: 'Modelo Sion  - Magistério 2 Anos',
    },
    {
        id: '35',
        nome: 'Modelo Supletivo Pré-Impresso',
    },
    {
        id: '36',
        nome: 'Modelo CEB',
    },
    {
        id: '37',
        nome: 'Certificado de Conclusão',
    },
    {
        id: '38',
        nome: 'Modelo Dom Pedro II',
    },
    {
        id: '39',
        nome: 'Modelo Cenel 1 a 5',
    },
    {
        id: '40',
        nome: 'Modelo Cenel 5 a 8',
    },
    {
        id: '41',
        nome: 'Modelo Escola Interação',
    },
    {
        id: '42',
        nome: 'Modelo Sagrada Família Ponta Grossa - Pr',
    },
    {
        id: '43',
        nome: 'Modelo Sagrada Família Ponta Grossa - Pr - Normal',
    },
    {
        id: '44',
        nome: 'Modelo 2003 - PR',
    },
    {
        id: '45',
        nome: 'Modelo Sant James',
    },
    {
        id: '46',
        nome: 'Modelo 2003 - B - PR',
    },
    {
        id: '47',
        nome: 'Modelo Instituto Educ. Infantil',
    },
    {
        id: '48',
        nome: 'Modelo Sion - Normal',
    },
    {
        id: '49',
        nome: 'Modelo NEC Estância dos Reis',
    },
    {
        id: '50',
        nome: 'Modelo Dom Pedro II - Novo',
    },
    {
        id: '51',
        nome: 'Modelo Escola Santa Terezinha',
    },
    {
        id: '52',
        nome: 'Modelo Colégio Educar',
    },
    {
        id: '53',
        nome: 'Modelo Escola Batista',
    },
    {
        id: '54',
        nome: 'Modelo Escola Cantinho Mágico',
    },
    {
        id: '55',
        nome: 'Modelo Escola Pontinha de Sol',
    },
    {
        id: '56',
        nome: 'Modelo São Camilo - Trimestral',
    },
    {
        id: '57',
        nome: 'Modelo Dom Pedro II - Médio',
    },
    {
        id: '58',
        nome: 'Modelo Anglo - 2004',
    },
    {
        id: '59',
        nome: 'Modelo Colégio Gamaliel',
    },
    {
        id: '60',
        nome: 'Modelo Colégio Educar Séries',
    },
    {
        id: '61',
        nome: 'Modelo INSEF 8 Anos',
    },
    {
        id: '62',
        nome: 'Modelo NDA Sênior',
    },
    {
        id: '63',
        nome: 'Modelo Colégio Evangélico Bom Samaritano',
    },
    {
        id: '64',
        nome: 'Modelo INSEF 9 Anos',
    },
    {
        id: '65',
        nome: 'Modelo 2003-PR A4',
    },
    {
        id: '66',
        nome: 'Modelo NDA Júnior',
    },
    {
        id: '67',
        nome: 'Modelo NDA Sênior II',
    },
    {
        id: '68',
        nome: 'Modelo Raizes',
    },
    {
        id: '69',
        nome: 'Modelo Escola Universo Infantil',
    },
    {
        id: '70',
        nome: 'Modelo Ceneb - Centro de Ensino Ebenézer',
    },
    {
        id: '71',
        nome: 'Modelo Colégio Auxiliadora - Trimestral',
    },
    {
        id: '72',
        nome: 'Modelo Colégio Cantinho Cristão',
    },
    {
        id: '73',
        nome: 'Modelo Colégio Educativo',
    },
    {
        id: '74',
        nome: 'Modelo São Camilo - Trimestral 2006',
    },
    {
        id: '75',
        nome: 'Modelo CEAV',
    },
    {
        id: '76',
        nome: 'Modelo Escola Magister',
    },
    {
        id: '77',
        nome: 'Modelo Escola Cantinho Mágico 9 Anos',
    },
    {
        id: '78',
        nome: 'Modelo CEB 9 Anos A4',
    },
    {
        id: '79',
        nome: 'Modelo Raízes 8 Anos',
    },
    {
        id: '80',
        nome: 'Modelo Colégio N.S. Aparecida - Uruaçu',
    },
    {
        id: '81',
        nome: 'Modelo Alfa-Objetivo Foz',
    },
    {
        id: '82',
        nome: 'Modelo Colégio Caminho',
    },
    {
        id: '83',
        nome: 'Modelo Colégio N.S. Aparecida',
    },
    {
        id: '84',
        nome: 'Modelo Colégio Santa Catarina de Sena',
    },
    {
        id: '85',
        nome: 'Modelo Anglo - 2006 - A4',
    },
    {
        id: '86',
        nome: 'Modelo EFTI',
    },
    {
        id: '87',
        nome: 'Modelo Escola Universo Infantil 9 Anos',
    },
    {
        id: '88',
        nome: 'Modelo Colégio Educativo 5 Anos',
    },
    {
        id: '89',
        nome: 'Modelo CEAV Anos',
    },
    {
        id: '90',
        nome: 'Modelo Educ. Nª Senhora Aparecida - SP 2007',
    },
    {
        id: '91',
        nome: 'Modelo 2007-PR-9 Anos',
    },
    {
        id: '92',
        nome: 'Modelo 2007-B-PR-9 Anos',
    },
    {
        id: '93',
        nome: 'Modelo Colégio N.S. Aparecida - Uruaçu Série/Ano',
    },
    {
        id: '94',
        nome: 'Certificado de Conclusão Uruaçu',
    },
    {
        id: '95',
        nome: 'Modelo 2007-9 Anos',
    },
    {
        id: '96',
        nome: 'Modelo CEB A4',
    },
    {
        id: '97',
        nome: 'Modelo Colégio Santa Catarina de Sena 9 Anos',
    },
    {
        id: '98',
        nome: 'Modelo MT Geral 9 Anos',
    },
    {
        id: '99',
        nome: 'Modelo 2007-8 Anos',
    },
    {
        id: '100',
        nome: 'Modelo Rede Vicentina - 2012',
    },
    {
        id: '101',
        nome: 'Modelo Sagrada Família Ponta Grossa - Pr - NormalPD',
    },
    {
        id: '102',
        nome: 'Modelo Raízes 2010',
    },
    {
        id: '103',
        nome: 'Modelo Modulus',
    },
    {
        id: '104',
        nome: 'Modelo Rede Santa Catarina de Sena',
    },
    {
        id: '105',
        nome: 'Modelo Bahia 9 Anos',
    },
    {
        id: '106',
        nome: 'Modelo Nossa Senhora do Carmo',
    },
    {
        id: '107',
        nome: 'Modelo Nossa Senhora do Carmo 2',
    },
    {
        id: '108',
        nome: 'Modelo Fátima',
    },
    {
        id: '109',
        nome: 'Modelo Sagrada Família Ponta Grossa - Pr - NormalPaisagem',
    },
    {
        id: '110',
        nome: 'Modelo São Camilo 2011',
    },
    {
        id: '111',
        nome: 'Modelo Educare 9 Anos 2011 - Disciplinas',
    },
    {
        id: '112',
        nome: 'Modelo Educare 9 Anos 2011 - Áreas do Conhecimento',
    },
    {
        id: '113',
        nome: 'Modelo Nobre 8 Anos / 9 Anos',
    },
    {
        id: '114',
        nome: 'Modelo Escola Ravelo',
    },
    {
        id: '115',
        nome: 'Modelo 2012-PR A4',
    },
    {
        id: '116',
        nome: 'Modelo Dom Pedro II 2012',
    },
    {
        id: '117',
        nome: 'Modelo Construtivo - 2012',
    },
    {
        id: '118',
        nome: 'Modelo Construtivo 9 Anos - 2012',
    },
    {
        id: '119',
        nome: 'Modelo Berlaar Santa Maria - 2013',
    },
    {
        id: '120',
        nome: 'Modelo Santo Angelo - 2013',
    },
    {
        id: '121',
        nome: 'Modelo Crescer no Saber - 2013',
    },
    {
        id: '122',
        nome: 'Modelo Sion - 2013',
    },
    {
        id: '123',
        nome: 'Modelo Rede Imaculada Virgem Maria - 2013',
    },
    {
        id: '124',
        nome: 'Modelo Sagrada Família Menino Deus',
    },
    {
        id: '125',
        nome: 'Modelo Rede Imaculada Virgem Maria - 2014',
    },
    {
        id: '126',
        nome: 'Modelo Educacional Filos - 2014',
    },
    {
        id: '127',
        nome: 'Modelo Santo Angelo - 2014',
    },
    {
        id: '128',
        nome: 'Modelo Militar Tiradentes - 2014',
    },
    {
        id: '129',
        nome: 'Modelo Colégio Padre Reus - 2014',
    },
    {
        id: '130',
        nome: 'Modelo Colégio Cencs - 2014',
    },
    {
        id: '131',
        nome: 'Modelo Colégio Anglo Americano - 2014',
    },
    {
        id: '132',
        nome: 'Modelo Colégio Evangélico - 2014',
    },
    {
        id: '133',
        nome: 'Modelo Colegio Anjos Custódio - 2015',
    },
    {
        id: '134',
        nome: 'Modelo Escola Billy Gancho',
    },
    {
        id: '135',
        nome: 'Modelo Escola Berlaar',
    },
    {
        id: '136',
        nome: 'Modelo Sion - 2015',
    },
    {
        id: '137',
        nome: 'Modelo Construindo o Saber',
    },
    {
        id: '138',
        nome: 'Modelo Colégio Berlaar Madre Blandina',
    },
    {
        id: '139',
        nome: 'Modelo Intentus',
    },
    {
        id: '140',
        nome: 'Modelo Presbiteriana do Gama',
    },
    {
        id: '141',
        nome: 'Modelo Colégio Referencial',
    },
    {
        id: '142',
        nome: 'Modelo Colégio Rio Branco Objetivo',
    },
    {
        id: '143',
        nome: 'Modelo Colégio Santa Cruz',
    },
    {
        id: '144',
        nome: 'Modelo Militar Tiradentes - 2016',
    },
    {
        id: '145',
        nome: 'Modelo Educação Infantil Paraná - 2017',
    },
    {
        id: '146',
        nome: 'Modelo PGD',
    },
    {
        id: '147',
        nome: 'Modelo Menino Deus',
    },
    {
        id: '148',
        nome: 'Modelo Educação Infantil Paraná - 2018',
    },
    {
        id: '149',
        nome: 'Modelo Colégio Baluarte',
    },
    {
        id: '150',
        nome: 'Modelo Educação Infantil Paraná - Trimestral',
    },
    {
        id: '151',
        nome: 'Modelo Centro Educacional Expoente',
    },
    {
        id: '152',
        nome: 'Modelo Centro de Ensino Logos',
    },
    {
        id: '153',
        nome: 'Modelo Educação Infantil Londrina',
    },
    {
        id: '154',
        nome: 'Modelo Rede Berlaar',
    },
    {
        id: '155',
        nome: 'Modelo Maple Bear',
    },
    {
        id: '156',
        nome: 'Modelo Escola Abelinha Feliz',
    },
    {
        id: '157',
        nome: 'Modelo Escola Rui Barbosa',
    },
    {
        id: '158',
        nome: 'Modelo Colégio Sagrada Família',
    },
    {
        id: '159',
        nome: 'Modelo Colégio Objetivo',
    },
    {
        id: '160',
        nome: 'Modelo Colégio Mapa',
    },
    {
        id: '161',
        nome: 'Modelo Colégio Sagrada Família Mandaguari',
    },
    {
        id: '162',
        nome: 'Modelo Colégio Gabriela Mistral',
    },
    {
        id: '163',
        nome: 'Modelo Escola Betel',
    },
    {
        id: '164',
        nome: 'Modelo Escola Notre Dame Infatil',
    },
    {
        id: '165',
        nome: 'Modelo Rede Vicentina - 2020',
    },
    {
        id: '166',
        nome: 'Modelo Centro Educacional Padre Mateus',
    },
    {
        id: '167',
        nome: 'Modelo Paraná (Fund. e Médio) - 2021',
    },
    {
        id: '168',
        nome: 'Modelo Centro de Ensino Logos',
    },
    {
        id: '169',
        nome: 'Modelo Colégio Maximus',
    },
    {
        id: '170',
        nome: 'Modelo Escola Libanesa',
    },
    {
        id: '171',
        nome: 'Modelo Saint Helena',
    },
    {
        id: '172',
        nome: 'Modelo Colégio SantAnna',
    },
];
